import React, { ReactElement, useContext } from 'react';
import Prompt from '..';
import { PromptContext } from './PromptProvider';
import { PromptContextType } from './types';

/**
 * custom hook to use notification context
 */
export function usePrompt(): Pick<PromptContextType, 'showPrompt'> {
  const { showPrompt } = useContext(PromptContext);
  return { showPrompt };
}

/**
 * component to display flashbar notification in the notification area
 * of Polaris AppLayout
 */
export function PromptView(): ReactElement {
  const { options, visible } = useContext(PromptContext);
  return (
    <Prompt
      title={options.title}
      type={options.type}
      visible={visible}
      body={options.body}
      onConfirm={options.onConfirm}
      onCancel={options.onCancel}
    />
  );
}
